import React, { useState } from "react";
import { FiFilter } from "react-icons/fi";
import AllOrders from "./TempTwoTabs/allOrders";
import Pending from "./TempTwoTabs/pending";
import { FaCalendar } from "react-icons/fa";
import { useAppSelector } from "../../../utils/redux/hooks";
import { RootState } from "../../../utils/redux/store";

const items = [
  "All Orders",
  "Pending",
  "Accepted",
  "In Progress",
  "In Dispute",
  "Completed",
  "Declined",
  "Cancelled",
];

const TempThree = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const viewCustomer: any = useAppSelector(
    (store: RootState) => store.user.viewCustomer
  );
  return (
    <div className="px-3">
      <div className="flex justify-between ">
        <div className="flex gap-10 text-[#88087B] items-center">
          <p className="font-roboto text-3xl font-medium leading-normal">
            {viewCustomer?.firstName} {viewCustomer?.lastName}
          </p>
          <p className="border-l-2 border-[#000] px-2 font-roboto text-lg font-medium leading-normal">
            Rating: {viewCustomer?.rating}
          </p>
          <p className="border border-[#000]  px-1 font-roboto text-lg font-medium leading-normal">
            Wallet Balance: ₦{" "}
            {viewCustomer?.wallet?.availableBalance.toLocaleString()}
          </p>
        </div>
        <FiFilter size={20} className="text-[#88087B]" />
      </div>
      <div className="flex gap-14 mb-4 bg-[#fff] px-2 py-3 rounded-md shadow-md">
        <p className="flex gap-4 font-roboto text-lg font-medium leading-normal">
          From:
          <div className="flex border border-[#88087B] items-center gap-2 px-2">
            <FaCalendar className="text-[#BDBDBD]" />{" "}
            <span className="font-roboto text-xs font-normal leading-normal">
              01 Sep 2023
            </span>
          </div>
        </p>
        <p className="flex gap-4 font-roboto text-lg font-medium leading-normal">
          To:
          <div className="flex border border-[#88087B] items-center gap-2 px-2">
            <FaCalendar className="text-[#BDBDBD]" />{" "}
            <span className="font-roboto text-xs font-normal leading-normal">
              01 Sep 2023
            </span>
          </div>
        </p>
        <button className="bg-[#88087B] px-6 rounded-md text-[#fff]">Go</button>
      </div>
      <div className="flex border-b-[0.1rem] border-[#000] justify-between">
        {items.map((item, index) => (
          <p
            key={index}
            className={`font-roboto text-base font-medium leading-normal cursor-pointer ${
              index === selectedTab ? "border-b-2 border-[#88087B]" : ""
            }`}
            onClick={() => setSelectedTab(index)}
          >
            {" "}
            {item}{" "}
            <span className="bg-[#88087B]  text-[#fff] text-sm px-1 rounded-sm">
              20
            </span>
          </p>
        ))}
      </div>
      {items.map((item, index) => (
        <div
          key={index}
          style={{
            display: index === selectedTab ? "block" : "none",
          }}
        >
          {index === 0 && <AllOrders user={viewCustomer} />}
          {index === 1 && <Pending />}
          {index === 2 && <div>Accepted</div>}
          {index === 3 && <div>In Progress</div>}
          {index === 4 && <div>In Dispute</div>}
          {index === 5 && <div>Completed</div>}
          {index === 6 && <div>Declined</div>}
          {index === 7 && <div>Cancelled</div>}
        </div>
      ))}
    </div>
  );
};

export default TempThree;
